/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function ($) {
  $(function () {
    if ($(window).width() > 800) {
      var sr = ScrollReveal();

      sr.reveal('.email-signup__body', {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }
  });

  function initEmailSignup() {
    $('.email-signup__form').each(function () {
      var $form = $(this);
      var $field = $form.find('.email-signup__field');
      var $inputWrap = $form.find('.email-signup__input-wrap');
      var $input = $form.find('.email-signup__input');
      var $label = $form.find('.email-signup__label');
      var $fakeBtn = $form.find('.email-signup__btn-fake');
      var $realBtn = $form.find('.email-signup__btn--hidden');
      var $errorMsg = $form.find('.email-signup__error-msg');

      var errorRequired = $field.data('error-required') || 'Email is required.';
      var errorInvalid = $field.data('error-invalid') || 'Please enter a valid email address.';

      $input.removeAttr('required');

      function updateLabel() {
        if ($input.val().length > 0 || $input.is(':focus')) {
          $label.addClass('email-signup__label--active');
        } else {
          $label.removeClass('email-signup__label--active');
        }
      }

      function showError(msg) {
        $field.addClass('email-signup__field--error');
        $inputWrap.find('.email-signup__icon--error').remove();
        $fakeBtn.before(
          '<span class="email-signup__icon email-signup__icon--error">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
          '<path d="M12.0001 16.2601C11.7001 16.2601 11.4451 16.1701 11.2501 15.9751C11.0551 15.7951 10.9651 15.5551 10.9651 15.2551C10.9651 14.9551 11.0551 14.7151 11.2501 14.5351C11.4451 14.3551 11.7001 14.2501 12.0001 14.2501C12.3001 14.2501 12.5701 14.3401 12.7651 14.5351C12.9601 14.7151 13.0501 14.9551 13.0501 15.2551C13.0501 15.5551 12.9601 15.7951 12.7651 15.9751C12.5701 16.1551 12.3151 16.2601 12.0001 16.2601ZM11.1601 13.3651L11.0251 7.35006H12.9301L12.7951 13.3651H11.1451H11.1601Z" fill="#C5333A"/>' +
          '<path d="M21.3149 12.0005C21.3149 6.8561 17.1448 2.68529 12.0005 2.68506C6.85596 2.68506 2.68506 6.85596 2.68506 12.0005C2.68529 17.1448 6.8561 21.3149 12.0005 21.3149C17.1447 21.3147 21.3147 17.1447 21.3149 12.0005ZM22.8149 12.0005C22.8147 17.9731 17.9731 22.8147 12.0005 22.8149C6.02767 22.8149 1.18529 17.9733 1.18506 12.0005C1.18506 6.02753 6.02753 1.18506 12.0005 1.18506C17.9733 1.18529 22.8149 6.02767 22.8149 12.0005Z" fill="#C5333A"/>' +
          '</svg></span>'
        );
        $errorMsg.text(msg).show();
      }

      function clearError() {
        $field.removeClass('email-signup__field--error');
        $inputWrap.find('.email-signup__icon--error').remove();
        $errorMsg.hide().text('');
      }

      updateLabel();

      $input.on('focus', function () {
        updateLabel();
      });

      $input.on('blur', function () {
        updateLabel();
      });

      $input.on('input', function () {
        clearError();
        updateLabel();
      });

      $fakeBtn.on('click', function () {
        var val = $input.val().trim();
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (val === '') {
          showError(errorRequired);
          return;
        }

        if (!emailRegex.test(val)) {
          showError(errorInvalid);
          return;
        }

        clearError();
        $realBtn.trigger('click');
      });
    });
  }

  $(document).ready(function () {
    initEmailSignup();
  });

  $(document).on('shopify:section:load', function (e) {
    $(e.target).find('.email-signup__form').length && initEmailSignup();
  });
})(jQuery);